<template>
	<div class="modal" :class="{ 'modal--dark': darkTheme }" @click="close">
		<div class="modal-holder" @click.stop>
			<span class="modal-title">
				Error of payment
			</span>

			<div class="modal-buttons">
				<span class="button single-button" @click="close">
					Ok
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PaymentErrorModal',
	props: {
		darkTheme: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		close() {
			this.$emit('close')
		}
	}
}
</script>
<style lang="scss" scoped>
.separator {
	margin: 0 5px 15px;
}
</style>
